// import React from "react";
// import { motion } from "framer-motion";

// const LotteryHome = () => {
//   const prizes = [
//     { no: "क्र. १", name: "स्विफ्ट डिझायर", img: "car.jpg", count: "5" },
//     { no: "क्र. २", name: "जॉन डिअर ट्रॅक्टर", img: "tractor.jpg", count: "5" },
//     { no: "क्र. ३", name: "बुलेट", img: "bullet.png", count: "5" },
//     { no: "क्र. ४", name: "होंडा शाईन", img: "honda-shine.jpg", count: "5" },
//     { no: "क्र. ५", name: "होंडा डिलक्स", img: "honda-dio.jpg", count: "10" },
//     { no: "क्र. ६", name: "इलेक्ट्रिक स्कुटी", img: "scooty.jpg", count: "10" },

//     { no: "क्र. ७", name: "वॉशिंग मशीन", img: "wm.jpg", count: "300" },
//     { no: "क्र. ८", name: "LED टीव्ही 32 इंच", img: "tv.jpg", count: "200" },
//     { no: "क्र. ९", name: "स्मार्ट फोन", img: "phone.jpg", count: "500" },
//     { no: "क्र. १०", name: "स्मार्ट वॉच", img: "watch.jpg", count: "500" },
//     { no: "क्र. ११", name: "बोट इअरबड्स", img: "earbuds.jpg", count: "1000" },
//     { no: "क्र. १२", name: "सरप्राईज", img: "gift.jpg" },
//   ];

//   return (
//     <div className="bg-[#f2f8ff] min-h-screen">

//       {/* HEADER */}
//       <motion.div
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.7 }}
//         className="w-full bg-blue-900 text-white p-4 flex flex-col md:flex-row justify-between items-center"
//       >
//         <div className="flex items-center gap-3">
//           <img src="logo1.png" className="h-16" alt="" />
//           <div>
//             <h1 className="text-xl font-bold">मेरुराम इंडिया टॅग प्रा. लि.</h1>
//             <p className="text-xs">CIN: U702200PN2024PTC233457</p>
//           </div>
//         </div>

//         <div className="flex items-center gap-3 mt-4 md:mt-0">
//           <img src="logo2.png" className="h-16" alt="" />
//           <div>
//             <h1 className="text-xl font-bold">मेरुराम अ‍ॅग्रो इंडिया प्रा. लि.</h1>
//             <p className="text-xs">GSTIN: 27AASCM4097N1ZG</p>
//           </div>
//         </div>
//       </motion.div>

//       {/* ANNOUNCEMENT */}
//       <motion.div
//         initial={{ opacity: 0, scale: 0.9 }}
//         animate={{ opacity: 1, scale: 1 }}
//         transition={{ duration: 0.6 }}
//         className="text-center mt-5"
//       >
//         <h2 className="text-red-600 font-bold text-2xl">खुशखबर ! खुशखबर !! खुशखबर !!!</h2>
//         <p className="mt-2 text-xl font-semibold">
//           मेरुराम कंपनीच्या प्रोत्साहन (प्रमोशन) करिता सर्वांसाठी घेऊन येत आहोत
//         </p>
//         <h1 className="text-4xl font-extrabold text-purple-700 mt-3">
//           भव्य बंपर लकी ड्रॉ !
//         </h1>
        
//       </motion.div>

//       {/* PRIZES GRID */}
//       <div className="max-w-6xl mx-auto mt-10 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-5 p-5">
//         {prizes.map((p, i) => (
//           <motion.div
//             key={i}
//             initial={{ opacity: 0, y: 40 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.4, delay: i * 0.1 }}
//             whileHover={{ scale: 1.05 }}
//             className="relative bg-white p-3 shadow-lg rounded-xl text-center border cursor-pointer"
//           >
//             {/* HEXAGON COUNT BADGE */}
// {p.count && (
//   <div
//     className="absolute top-2 right-2 bg-blue-400 text-black font-bold flex items-center justify-center shadow"
//     style={{
//       width: "40px",
//       height: "28px",
//       clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
//       fontSize: "14px",
//       padding: "10px 0",
//     }}
//   >
//     {p.count}
//   </div>
// )}
//             <div className="bg-pink-500 text-white rounded-full px-3 py-1 text-sm font-bold w-fit mx-auto">
//               {p.no}
//             </div>

//             <motion.img
//               src={p.img}
//               alt=""
//               className="h-24 mx-auto my-3"
//               whileHover={{ scale: 1.1 }}
//             />

//             <p className="font-semibold">{p.name}</p>
//           </motion.div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default LotteryHome;


import React from "react";
import { motion } from "framer-motion";

const LotteryHome = () => {
  return (
    <div className="min-h-screen bg-[#f2f8ff] flex flex-col">

      {/* ================= HEADER ONLY ================= */}
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full bg-[#f2f2f2] py-4 sm:py-6 md:py-8"
      >
        <div className="max-w-7xl mx-auto relative flex flex-col md:flex-row items-stretch justify-between px-3 sm:px-4 gap-6 md:gap-0">

          {/* LEFT PANEL */}
          <div className="flex-1 bg-blue-800 rounded-2xl md:rounded-b-[45px] md:rounded-t-2xl p-5 sm:p-6 md:p-10 
                          flex flex-col items-center justify-center shadow-xl 
                          min-h-[280px] sm:min-h-[340px] md:min-h-[480px]">

            <h1 className="text-white text-sm sm:text-lg md:text-2xl font-bold text-center">
              Meruram India Tag Pvt. Ltd.
            </h1>

            <div className="mt-3 border-2 border-yellow-400 text-yellow-300 
                            px-3 sm:px-4 md:px-6 py-1.5 md:py-2 
                            rounded-lg text-[10px] sm:text-sm md:text-base font-semibold text-center">
              CIN: U702200PN2024PTC233457
            </div>

            <img
              src="logo1.png"
              className="h-28 sm:h-36 md:h-56 lg:h-64 mt-5 object-contain"
              alt="logo1"
            />
          </div>

          {/* CENTER DIVIDER */}
          <div className="flex md:flex-col items-center justify-center relative px-2 md:px-4">

            {/* Divider */}
            <div className="hidden md:block h-full w-[14px] bg-gray-300 rounded-full"></div>
            <div className="block md:hidden w-full h-[6px] bg-gray-300 rounded-full"></div>

            {/* Welcome Badge */}
            <div className="absolute bg-blue-900 text-white 
                            px-4 sm:px-6 md:px-8 py-1.5 md:py-2 
                            rounded-lg font-semibold shadow-xl 
                            text-xs sm:text-sm md:text-lg">
              Welcome
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="flex-1 bg-blue-900 rounded-2xl md:rounded-b-[45px] md:rounded-t-2xl p-5 sm:p-6 md:p-10 
                          flex flex-col items-center justify-center shadow-xl 
                          min-h-[280px] sm:min-h-[340px] md:min-h-[480px]">

            <h1 className="text-white text-sm sm:text-lg md:text-2xl font-bold text-center">
              Meruram Agro India Pvt. Ltd.
            </h1>

            <div className="mt-3 border-2 border-yellow-400 text-yellow-300 
                            px-3 sm:px-4 md:px-6 py-1.5 md:py-2 
                            rounded-lg text-[10px] sm:text-sm md:text-base font-semibold text-center">
              GSTIN: 27AASCM4097N1ZG
            </div>

            <img
              src="logo2.png"
              className="h-28 sm:h-36 md:h-56 lg:h-64 mt-5 object-contain"
              alt="logo2"
            />
          </div>

        </div>
      </motion.div>

    </div>
  );
};

export default LotteryHome;
